var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"dwt-container"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.scanUrl,"frameborder":"0","id":"","name":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }